import { StreamOperation } from '@injectivelabs/ts-types'
import {
  streamVault as grpcStreamVault,
  cancelVaultStream as grpcCancelVaultStream,
  streamVaultTransfers as grpcStreamVaultTransfers,
  streamVaultHolderSubscription as grpcStreamVaultHolderSubscription
} from '@/app/client/streams/mito'
import { UiMitoTransformer } from '@/app/client/transformers/mito'
import { UiVault, EventBus } from '@/types'

export const cancelVaultStream = grpcCancelVaultStream

export const streamVault = (vaultAddress: string) => {
  const mitoStore = useMitoStore()

  grpcStreamVault({
    vaultAddress,
    callback: ({ vault, opType }) => {
      if (!vault) {
        return
      }

      const uiVault = UiMitoTransformer.vaultToUiVault(vault) as UiVault

      switch (opType) {
        case StreamOperation.Insert: {
          mitoStore.$patch({
            vaults: [uiVault, ...mitoStore.vaults]
          })

          break
        }
        case StreamOperation.Update: {
          const vaultFromStore = mitoStore.vaults.find(
            (vault) => uiVault.contractAddress === vault.contractAddress
          )

          mitoStore.$patch({
            vaults: vaultFromStore
              ? [
                  {
                    ...uiVault,
                    profits: vaultFromStore.profits,
                    tvlChanges: vaultFromStore.tvlChanges
                  },
                  ...mitoStore.vaults.filter(
                    (v) => v.contractAddress !== uiVault?.contractAddress
                  )
                ]
              : [uiVault, ...mitoStore.vaults]
          })

          break
        }
      }
    }
  })
}

export const streamVaultTransfers = () => {
  const sharedWalletStore = useSharedWalletStore()

  if (!sharedWalletStore.injectiveAddress) {
    return
  }

  grpcStreamVaultTransfers({
    accountAddress: sharedWalletStore.injectiveAddress,
    callback: ({ transfer }) => {
      if (!transfer) {
        return
      }

      useEventBus(EventBus.StreamVaultTransferUpdate).emit()
    }
  })
}

export const streamHolderSubscription = () => {
  const mitoStore = useMitoStore()
  const sharedWalletStore = useSharedWalletStore()

  if (!sharedWalletStore.injectiveAddress) {
    return
  }

  grpcStreamVaultHolderSubscription({
    holderAddress: sharedWalletStore.injectiveAddress,
    callback: ({ subscription, opType }) => {
      if (!subscription) {
        return
      }

      const uiSubscription =
        UiMitoTransformer.subscriptionToUiSubscription(subscription)

      if (!uiSubscription) {
        return
      }

      switch (opType) {
        case StreamOperation.Insert: {
          mitoStore.$patch({
            holderSubscriptions: [
              uiSubscription,
              ...mitoStore.holderSubscriptions
            ]
          })

          break
        }
        case StreamOperation.Update: {
          mitoStore.$patch({
            holderSubscriptions: [
              uiSubscription,
              ...mitoStore.holderSubscriptions.filter(
                (s) =>
                  s.vaultInfo.contractAddress !==
                  uiSubscription?.vaultInfo?.contractAddress
              )
            ]
          })

          break
        }
      }
    }
  })
}
